import { FormSectionHeader } from "@/components";
import { cn, formatAmount } from "@/lib/utils";

const PaymentTimeline = ({ paymentCards, onTimelineCardClick }: any) => {
  return (
    <div className="mt-[10px]">
      <FormSectionHeader>Payment Timeline</FormSectionHeader>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-5 mb-10">
        {paymentCards?.map((data: any) => {
          return (
            <div className="rounded-md bg-primary cursor-pointer" onClick={() => onTimelineCardClick(data?.filter)}>
              <div className="rounded-md bg-primary-300 p-3 mb-3">
                <div
                  className={cn(
                    "text-[14px] text-gray-500",
                    !data?.title && "h-[20px]"
                  )}
                >
                  {data?.title || ""}
                </div>
                <div className="flex flex-row items-center justify-between mt-3">
                  <div className="bg-white rounded-md shadow-sm flex items-center justify-center p-3 h-[60px] w-[60px]">
                    {data?.icon}
                  </div>
                  <div className="flex flex-col items-end">
                    <span className="text-[24px] font-[600] text-primary">
                      {data?.count}
                    </span>
                    <span className="text-[12px]">
                      Amount:{" "}
                      <span className="text-primary">
                        {formatAmount(data?.amt)}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentTimeline;
